module.exports = __webpack_public_path__ + "pc/static/img/logo.9ba4741c.png";